import { axiosPrivate } from '../../api/axios';

export const fetchUsuariosOnline = async () => {
    const { data } = await axiosPrivate.get('/api/usuarios-online');
    return data;
};

export const fetchUsuariosOnlineMetrics = async ({ period = 'today', userCategory = 'all' } = {}) => {
    const { data } = await axiosPrivate.get('/api/usuarios-online/metrics', {
        params: { period, userCategory },
    });
    return data;
};

export const fetchUsuariosOnlineHistory = async (payload = {}) => {
    const { data } = await axiosPrivate.post('/api/usuarios-online/history', payload);
    return data;
};
